import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function BrandPanel() {
  return (
    <div className="hidden lg:flex lg:w-[480px] xl:w-[540px] relative overflow-hidden flex-shrink-0 brand-gradient flex-col items-center justify-center p-12">
      {/* Decorative blobs */}
      <div
        className="decorative-blob w-72 h-72 bg-white"
        style={{ top: '-60px', left: '-60px' }}
      />
      <div
        className="decorative-blob w-64 h-64"
        style={{ bottom: '-40px', right: '-40px', background: '#ff2490' }}
      />
      <div
        className="decorative-blob w-40 h-40 bg-white"
        style={{ bottom: '120px', left: '-20px' }}
      />
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center">
        {/* Logo */}
        <div className="w-28 h-28 rounded-3xl bg-white/20 backdrop-blur-sm border-4 border-white/40 flex items-center justify-center shadow-brand-lg mb-6">
          <div className="flex items-center gap-2">
            <AppLogo size={64} className="drop-shadow-sm" />
          </div>
        </div>

        <h1 className="text-4xl font-extrabold text-white mb-2 tracking-tight drop-shadow-sm">
          LazosLeis
        </h1>
        <p className="text-white/80 text-lg font-medium italic mb-10">
          El arte de personalizar
        </p>

        {/* Feature bullets */}
        <div className="flex flex-col gap-4 w-full max-w-xs">
          {[
            { icon: '🎀', text: 'Productos únicos y personalizados' },
            { icon: '📦', text: 'Seguimiento de pedidos en tiempo real' },
            { icon: '💜', text: 'Diseños exclusivos para ti' },
          ]?.map((item) => (
            <div
              key={`feature-${item?.icon}`}
              className="flex items-center gap-3 bg-white/15 backdrop-blur-sm rounded-xl px-4 py-3 border border-white/20"
            >
              <span className="text-xl">{item?.icon}</span>
              <span className="text-white/90 text-sm font-medium">{item?.text}</span>
            </div>
          ))}
        </div>

        {/* Bottom tagline */}
        <p className="text-white/60 text-xs mt-10 font-medium tracking-wide uppercase">
          Hecho con amor · Venezuela 🇻🇪
        </p>
      </div>
    </div>
  );
}